var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('single-list-filter',[_c('filter-list-item',{scopedSlots:_vm._u([{key:"default",fn:function({ isHover }){return [_c('warranted-filter',{attrs:{"selected":_vm.isFilterSelected,"isHover":isHover},on:{"change":_vm.startSearchByQuickInformation}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }